import photo1 from "../images/Rectangle25.png"
import photo2 from "../images/Rectangle26.png"
import photo3 from "../images/Rectangle27.png"
import photo4 from "../images/Rectangle28.png"
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    name: 'Blockchain Conference',
    imageSrc: photo1,
    date: "16 July 2024 ",
    price: '$35',
    location: 'Black',

  },
  {
    id: 2,
    name: 'Swiss Blockchain Capital Day',
    imageSrc: photo2,
    date: "3-5 October",
    price: '$35',
    location: 'Zurich, Zurich',

  },
  {
    id: 3,
    name: 'Blockchain Summit',
    imageSrc: photo3,
    date: "14-16 December",
    price: '$35',
    location: 'Dubai, UEA',

  },
  {
    id: 4,
    name: 'Coin Agenda EMEA',
    imageSrc: photo4,
    date: "18-22 January",
    price: '$150',
    location: 'Bangalore, India',

  },

  // More products...
]

export default function LaterEvents() {
  return (
    <div className="bg-background">
      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
        <h2 className="text-2xl font-title text-white">Later This Year</h2>

        <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {products.map((product) => (
            <Link
              to="/purchase"
            >
              <div key={product.id} className="group relative">
                <div className="aspect-w-1 w-full h-64 overflow-hidden bg-gray-200 lg:aspect-none group-hover:scale-105 transition duration-500 cursor-pointer lg:h-64">
                  <img
                    src={product.imageSrc}
                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                  />
                </div>
                <div className="mt-4 flex justify-between">
                  <div>
                    <h3 className="text-lg not-italic font-bold font-title leading-6 text-white">
                      <a href={product.href}>
                        <span aria-hidden="true" className="absolute inset-0" />
                        {product.name}
                      </a>
                    </h3>
                    <p className="mt-2 text-sm not-italic font-medium font-text leading-5 text-white">{product.date}</p>
                    <p className="mt-2 text-sm not-italic font-medium leading-5 font-text text-white">{product.location}</p>
                  </div>
                  <p className=" mt-10 pt-5 text-base not-italic font-bold font-text leading-6 text-blue">{product.price}</p>
                </div>
              </div>
            </Link>

          ))}
        </div>
      </div>
    </div>
  )
}